var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / how-step-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-17.6%",
    width: "139.9%",
    height: "135.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC3E7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E286D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.881238,27.4885134 C27.0655816,31.6873524 23.3803869,34.8589029 18.9702481,34.8589029 L18.9702481,34.8589029 L14.6500666,34.8589029 C10.2399279,34.8589029 6.55473315,31.6873524 5.76931426,27.4885134 C6.82687033,27.7304131 7.88442641,27.8510005 9.00170223,27.8510005 L9.00170223,27.8510005 L24.6186125,27.8510005 C25.7366435,27.8510005 26.8236819,27.7304131 27.881238,27.4885134 Z M33.6203148,0 L33.6203148,12.8380843 C33.6203148,17.7921047 29.6032631,21.8095491 24.6186125,21.8095491 L24.6186125,21.8095491 L9.00170223,21.8095491 C4.04804433,21.8095491 0,17.7921047 0,12.8380843 L0,12.8380843 L0,0 L33.6203148,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1230923%",
    y1: "54.3829271%",
    x2: "26.6681613%",
    y2: "76.2683647%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.9636378%",
    y1: "15.1651008%",
    x2: "70.3805296%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.8585104,0 C8.21549812,0 -8.8520251,28.7876067 4.83192282,52.4401308 C6.55394793,55.8535508 18.1538066,69.8395411 18.0328567,77.8743997 L18.0328567,78.4485188 L51.6531715,78.4485188 L51.6531715,77.8743997 C51.6531715,77.8139248 51.622934,77.7836873 51.622934,77.7538123 C51.6531715,71.1382417 57.5139533,64.0093592 65.0052927,52.2284685 C78.507846,28.7876067 61.3798479,0 34.8585104,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.7598107%",
    y1: "44.4856839%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5396039%",
    y1: "44.4856839%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "49.1923567%",
    x2: "50%",
    y2: "57.3231504%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "49.1915735%",
    x2: "50%",
    y2: "57.3302521%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "44.4920146%",
    x2: "50%",
    y2: "99.9425974%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-how-step-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.847650, 2.500000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(47.445905, 110.141097)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5510358,-42.9399859 L16.8360485,-66.3693781 C34.902764,-36.3378173 37.5844938,-13.0585394 24.881238,3.46845541 C12.1779821,19.9954503 -0.0469486968,29.8384873 -11.7935545,32.9975664 C44.054669,41.3805652 80.304684,42.0010107 96.9564906,34.8589029 C113.608297,27.7167952 101.806479,1.78383223 61.5510358,-42.9399859 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(29.413048, 25.651097)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5838925,10.5500145 L37.8689053,-12.8793776 C55.9356207,17.1521832 58.6173505,40.431461 45.9140947,56.9584559 C33.2108388,73.4854507 20.985908,83.3284877 9.23930217,86.4875669 C65.0875257,94.8705656 101.337541,95.4910112 117.989347,88.3489034 C134.641154,81.2067957 122.839336,55.2738327 82.5838925,10.5500145 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.2612274,15.7939248 C65.9308731,15.7939248 67.2819531,14.4399147 67.2819531,12.771719 L67.2789928,3.01924556 C67.2789928,1.35104979 65.9249827,0 64.258267,0 C62.5886213,0 61.2375413,1.3540101 61.2375413,3.02220588 L61.2405016,12.7746793 C61.2405016,14.4428751 62.5945419,15.7939248 64.2612274,15.7939248 Z",
    id: "Path",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.061686,18.9710033 L98.1676955,25.8708846 C96.9877094,27.0523206 96.9877094,28.9638963 98.1676955,30.1438522 C99.3485878,31.3217842 101.259197,31.3223883 102.439183,30.142372 L109.333174,23.2424907 C110.51316,22.0610547 110.51316,20.149479 109.333174,18.9695232 C108.153218,17.7924974 106.241642,17.7910172 105.061686,18.9710033 Z",
    id: "Path",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.770139,61.2375715 L115.017666,61.2405318 C113.34802,61.2405318 111.99694,62.5945419 111.99694,64.2612576 C111.99694,65.9309033 113.35095,67.2819833 115.017666,67.2819833 L124.770139,67.279023 C126.439785,67.279023 127.790865,65.9250129 127.790865,64.2582973 C127.790865,62.5886213 126.436855,61.2375715 124.770139,61.2375715 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7731991,60.505982 C12.7731991,60.505982 12.7731991,60.505982 12.7702388,60.505982 L3.01776541,60.5118724 C1.35104979,60.5118724 0,61.8658825 0,63.5355584 C0,65.202274 1.3540101,66.5533238 3.02072572,66.5533238 C3.02072572,66.5533238 3.02072572,66.5533238 3.02368603,66.5533238 L12.7761594,66.5474334 C14.4428751,66.5474334 15.7939248,65.1934233 15.7939248,63.5237474 C15.7939248,61.8570318 14.4399147,60.505982 12.7731991,60.505982 Z",
    id: "Path",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.142372,25.3487522 L23.2424907,18.4562415 C22.0625046,17.2792157 20.1450688,17.2762554 18.9710033,18.4592018 C17.7910172,19.6391879 17.7910172,21.5522135 18.9710033,22.7306892 L25.8708846,29.6231999 C27.0577579,30.8071129 28.9753146,30.7961175 30.142372,29.6202396 C31.3223581,28.4402535 31.3223581,26.5272279 30.142372,25.3487522 Z",
    id: "Path",
    fill: "url(#linearGradient-13)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowStep2);
export default __webpack_public_path__ + "static/media/how-step-2.fb8ea1fd94373016df53348d85dd219b.svg";
export { ForwardRef as ReactComponent };